import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import DisparoAlertas from "../views/DisparoAlertas.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: DisparoAlertas,
  },
  {
    path: "/disparaAlertas",
    name: "Alertas",
    component: DisparoAlertas,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
